<template>
  <div class="content">
    <product-form-modal :product="dataall"></product-form-modal>
    <unit></unit>
    <model></model>
    <extraunit></extraunit>
    <brand></brand>
    <colour></colour>
    <country></country>
    <b-modal id="modal-close" centered>
      <h4>
        {{$t('Sizda saqlanmagan malumotlar mavjud. Saqlansinmi?')}}
      </h4>

      <template #modal-footer="{ ok, cancel, hide }">
        <button type="button" class="btn btn-success" style="margin-bottom: 16px;"
          @click="$root.$refs.product.Savedokument()">{{$t('Да')}}</button>
        <button type="button" class="btn btn-danger" @click='Home()'>{{$t('Нет')}}</button>
        <button type="button" class="btn btn-primary" @click="cancel()">{{$t('Отмена')}}</button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import { ProductFormModal, Extraunit,Unit, Model, Brand, Colour, Country } from "@/pages";
export default {
  components: { ProductFormModal,Extraunit, Unit, Model, Brand, Colour, Country },
  data() {
    return {
      dataall: {
        see:true,
        name: localStorage.getItem("product_name"),
        unit_id: 0,
        parent_id: 0,
        minimum_amount:1,
        is_folder: 0,
        extra_unit_id1: 0,
        extra_unit_id2: 0,
        model_id: 0,
        country_id: 0,
        brand_id: 0,
        colour_id: 0,
        quality: "",
        picture_name: "",
        number:0,
        code: "",
        extra_name: "",
        pack_count:1,
        shtrix_table: [{ shtrix_kod: "" }]
      }
    };
  },
  watch: {
    dataall: {
      deep: true,
      handler(val, oldVal) {
        this.$store.state.saved += 1;
      }
    }
  },
  methods:{
    Home() {
        this.$store.state.saved = null;
        this.$bvModal.hide('modal-close');
          this.$router.push({ name: "Товар модал" });
      },
    LastNumber(){
      let self=this;
      axios
        .get("api/v1/product/last-number")
        .then(function(response) {
            self.dataall.number=response.data.number;
        });
    }
  },
  created: function() {
    let self = this;
    if (self.$route.params.copy) {
      axios
        .get("api/v1/product/id/" + self.$route.params.copy)
        .then(function(response) {
          self.dataall = response.data;
          self.LastNumber();
          self.dataall.shtrix_table=[{ shtrix_kod: "" }];
        });
    }else{
      if(localStorage.getItem('shtrix_code')){
      self.dataall.shtrix_table[0].shtrix_kod=localStorage.getItem('shtrix_code');
    }
    self.LastNumber();
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.$store.state.saved < 2) {
      this.$store.state.saved = null;
      localStorage.removeItem("shtrix_code");
      localStorage.removeItem("product_name");
      next();
    } else {
      this.$bvModal.show("modal-close");
    }
  }
};
</script>
